import React from 'react';
import { IconCheck } from '../../../app/icons/check';
import { IconCopy } from '../../../app/icons/copy';

interface CampaignPromoBannerCodeProps {
    code: string;
    copied: boolean;
    copiedLabel: string;
    copyLabel: string;
    wrapperStyle: React.CSSProperties;
    buttonStyle: React.CSSProperties;
    onCopyCode: () => void;
}

export const CampaignPromoBannerCode: React.FC<CampaignPromoBannerCodeProps> = ({
    code,
    copied,
    copiedLabel,
    copyLabel,
    wrapperStyle,
    buttonStyle,
    onCopyCode,
}) => (
    <div
        className="mt-[1.4rem] inline-flex items-center justify-center gap-small rounded-[99rem] border border-solid bg-neutral-white px-[1.8rem] py-[0.8rem] text-[1.6rem] font-black tracking-[0.12em] text-brand-primary lg:mt-0 lg:shrink-0 lg:self-center"
        style={wrapperStyle}
    >
        <span className="inline-flex items-center">{code}</span>
        <button
            type="button"
            onClick={onCopyCode}
            className="inline-flex h-[3.8rem] w-[3.8rem] items-center justify-center rounded-full border-0 transition-opacity hover:opacity-[0.88] [&_i]:h-[1.6rem] [&_i]:w-[1.6rem]"
            aria-label={copied ? copiedLabel : copyLabel}
            style={buttonStyle}
        >
            {copied ? <IconCheck /> : <IconCopy />}
        </button>
    </div>
);
